import React from "react";
import AllProducts from "../Components/AllStickers/AllStickers";

const Stickers = () => {
  return (
    <div>
      <AllProducts />
    </div>
  );
};

export default Stickers;
